<template>
  <div class="p-2 rounded-lg bg-white">
    <div>
      <div v-if="!hideText">
        <h3 class="text-lg leading-6 font-medium text-blue-700">
          Spouse Information
        </h3>
      </div>
      <div
        :class="hideText ? 'mt-2' : 'mt-6'"
        class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
      >
        <div class="sm:col-span-6">
          <label
            for="first-name"
            class="block text-sm font-medium text-gray-700"
          >
            Name
          </label>
          <div class="mt-1">
            <input
              type="text"
              v-model="user.profile.spouse_name"
              class="bg-white text-gray-400 shadow-sm focus:ring-indigo-500 p-1 border focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
            />
          </div>
        </div>

        <div class="sm:col-span-3">
          <label
            for="first-name"
            class="block text-sm font-medium text-gray-700"
          >
            Phone
          </label>
          <div class="mt-1">
            <input
              type="text"
              v-model="user.profile.spouse_phone"
              class="bg-white text-gray-400 shadow-sm focus:ring-indigo-500 p-1 border focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
            />
          </div>
        </div>

        <div class="sm:col-span-3">
          <label for="email" class="block text-sm font-medium text-gray-700">
            Email address
          </label>
          <div class="mt-1">
            <input
              type="email"
              autocomplete="email"
              v-model="user.profile.spouse_email"
              class="p-1 bg-white text-gray-400 border shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
            />
          </div>
        </div>
      </div>

      <button
        @click.prevent="saveSpouse(user)"
        class=" mt-2 inline-flex justify-center py-1 px-3 border border-transparent shadow-sm text-sm font-medium rounded-lg text-white bg-green-600 hover:bg-green-700 focus:outline-none"
      >
        Save
      </button>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
  props: ["user", "hideText"],
  data() {
    return {};
  },

  methods: {
    saveSpouse(user) {
      window.axios
        .post("/api/addSpouse/" + user.id, {
          name: user.profile.spouse_name,
          email: user.profile.spouse_email,
          phone: user.profile.spouse_phone
        })
        .then(() => {
          this.$store.dispatch("getUser");
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Spouse successfully updated",
            showConfirmButton: false,
            timer: 1500
          });
        });
    }
  }
};
</script>
